<template>
  <va-card title="Меню">
    <va-data-table
      :fields="fields"
      :data="menus"
      no-pagination
    >
      <template slot="marker" slot-scope="props">
        <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
      </template>

      <template slot="toggle" slot-scope="props">
        <va-toggle
          small
          v-on:input="togglePublished(props.rowData.id)"
          v-model="props.rowData.published"
        />
      </template>

      <template slot="translations" slot-scope="props">
        <va-badge color="info" :outline="!translation.status" v-for="(translation, index) in props.rowData.trans" :key="index">{{ translation.locale }}</va-badge>
      </template>

      <template slot="actions" slot-scope="props">
        <va-button
          small
          color="info"
          :to="{ name: 'bgk-menu-edit', params: { id: props.rowData.id } }"
        >
          Редагувати
        </va-button>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  data () {
    return {
      menus: [],
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    fields () {
      return [{
        name: 'label',
        title: 'Label',
        width: '25%',
      },
      {
        name: 'position',
        title: 'Позиція',
        width: '10%',
      },
      {
        title: 'Опубліковано',
        name: '__slot:toggle',
        width: '20%',
      },
      {
        title: 'Переклади',
        name: '__slot:translations',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    togglePublished (id) {
      axios.put(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/menu/${id}`, {
        published: !!this.menus.find((item) => item.id === id).published,
      })
        .then(response => {
          this.showToast('Success')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    fetch () {
      // TODO: change uk to locale value
      axios.get(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/menu`)
        .then(response => {
          this.menus = response.data
          this.menus.forEach((item) => {
            item.published = !!item.published
            // console.log(item.trans)
          })
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
        .finally(() => {
          this.loaded = true
        })
    },
  },
}
</script>

<style lang="scss">
</style>
